const CollaborateSharedDataHistory = () => {
  return "collaborate shared data history not implemented";
};
export default CollaborateSharedDataHistory;
